<template>
  <div v-if="isLoggedIn && user.id">
    <AdminToolBar v-if="user.permission.length" />
    <AdminSidebar v-if="user.permission.length" />

    <v-main class="grey lighten-3">
      <div :style="`margin-left: ${contentAreaStyle.marginLeft};`">
        <v-container
          class="py-10 px-10"
          fluid
        >
          <version-banner />
          <router-view />
        </v-container>
      </div>
    </v-main>
    <notification />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Notification from '../../components/notification.vue';
import VersionBanner from '../../components/VersionBanner.vue';
import AdminSidebar from './AdminSidebar.vue';
import AdminToolBar from './AdminToolbar.vue';

export default {
  components: {
    AdminSidebar,
    AdminToolBar,
    Notification,
    VersionBanner,
  },
  computed: {
    ...mapState('currentUser', ['user', 'isLoggedIn']),
    ...mapState('sidebar', ['contentAreaStyle']),
  },
  async created() {
    this.setContentAreaStyle();
    if (!this.user?.id) {
      this.getUser();
    }
  },
  methods: {
    ...mapActions('currentUser', ['getUser']),
    ...mapActions('sidebar', ['setContentAreaStyle']),
  },
};
</script>

<style scoped>
.v-application .grey.lighten-3 {
  background: #f1f7f0 !important;
  background-blend-mode: normal;
  padding: 0 !important;
  min-height: 100vh;
}
</style>

<style>
.ag-theme-alpine {
  max-height: 65vh;
  height: 65vh !important;
}
.ag-theme-alpine .ag-root-wrapper.ag-layout-normal {
  border: none;
  background: transparent;
  box-shadow: 3px 3px 10px #cccccc;
}
thead.v-data-table-header, .ag-header {
  background: #e9eaec !important;
}

thead th.v-data-table__td.v-data-table-column--align-start.v-data-table__th{
    background: #e9eaec !important;
    padding: 1rem !important;
    border-right: 1px solid #999999;
    color: #4d4d4d !important;
    font-weight: bold;
    font-size: 0.9rem !important;
}

thead.v-data-table-header th, .v-data-table thead th, .ag-header .ag-header-cell {
  padding: 1rem !important;
  border-right: 1px solid #999999;
  color: #4d4d4d !important;
  font-weight: bold;
  font-size: 0.9rem !important;
}
tbody td, .ag-cell-value, td.v-data-table__td {
  padding: 0.5rem 0.5rem !important;
  color: #4d4d4d;
}
tbody tr:nth-child(odd), .ag-row-odd {
  background-color: #ffffff;
}
tbody tr:nth-child(even), .ag-row-even {
  background-color: #f7f7f8 !important;
}

.v-table header.v-toolbar.v-toolbar--collapse-start.v-toolbar--flat.v-toolbar--density-default.v-theme--light.v-locale--is-ltr {
  background: transparent;
}

.v-table, .v-data-table {
  background-color: transparent !important;
}
.v-data-table .theme--light.v-toolbar.v-sheet {
  background-color: transparent;
}
.v-data-table .v-toolbar__title {
  font-size: 1.3rem;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #2b3243;
  font-weight: bold;
  text-transform: uppercase;
}

.v-data-table .v-toolbar .v-input {
  border: 1px solid #cccccc;
  padding: 0rem 1rem;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-width: 300px;
}

.v-data-table .v-toolbar .v-input .v-input__slot {
  background: #fff !important;
  padding: 0.5rem 1rem;
  min-height: 40px;
}

.v-data-table .v-toolbar .v-input .v-input__slot:before,
.v-data-table .v-toolbar .v-input .v-input__slot:after {
  border: none !important;
}

.v-data-table .v-toolbar .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border: none;
}

.v-data-table .v-toolbar .v-text-field input {
  padding: 0;
  background-color: white;
}

.v-data-table .v-toolbar .v-text-field .v-input__append-inner {
  margin-top: 8px;
}

.v-data-table .v-toolbar .v-text-field .v-icon {
  color: #999999;
}

.btn-bg-regal-gray {
  background: #7d959d !important;
  color: #ffffff !important;
}
.btn-bg-deep-blue {
  background: #205e86 !important;
  color: #ffffff !important;
}
.btn-bg-gunmetal {
  background: #2b3243 !important;
  color: #ffffff !important;
}
.btn-bg-teal {
  background: #45a9a5 !important;
  color: #ffffff !important;
}
.btn-bg-alert-red {
  background: #95291f !important;
  color: #ffffff !important;
}

.v-icon {
  -webkit-text-stroke: 1px inherit;
}

.headline {
  font-size: 1.5rem !important;
  color: #2b3243 !important;
  font-weight: bold !important;
  text-transform: uppercase;
}

.v-tabs {
  box-shadow: 1px 1px 2px 0px #999999;
  background-color: #ffffff !important;
  margin-bottom: 1.5rem;
}

.v-tabs a.v-tab {
  color: #205e86 !important;
  /* text-decoration: underline; */
  padding: 1rem 2rem !important;
  font-size: 0.85rem;
  font-weight: bold;
}

.v-tabs a.v-tab--active.v-tab{
  font-weight: bold;
  text-decoration: none;
}
/* Multiple selectors to ensure compatibility with Vuetify 3 */
.v-tabs .v-tabs-slider,
.v-tabs .v-tab-indicator,
.v-tabs .v-tabs__slider,
.v-tabs-slider-wrapper,
.v-tab__slider {
  background-color: #b61e4e !important;
  height: 2px !important;
}

/* Target the active tab's bottom border directly */
.v-tabs .v-tab--selected::after,
.v-tabs .v-tab.v-tab--selected {
  border-bottom: 2px solid #b61e4e !important;
}

.v-tabs.v-tabs--vertical a.v-tab,
.v-tabs.v-tabs--direction-vertical a.v-tab {
  color: #205e86 !important;
  text-decoration: none !important;
  padding: 1rem 0.8rem !important;
  font-size: 0.8rem;
  font-weight: 500;
  justify-content: left;
}
.v-tabs.v-tabs--vertical a.v-tab--active.v-tab,
.v-tabs.v-tabs--direction-vertical a.v-tab--active.v-tab,
.v-tabs.v-tabs--direction-vertical a.v-tab--selected.v-tab {
  background: #999999 !important;
}

.v-dialog .v-card__title {
  background: #f1f7f0 !important;
}

.v-card-title {
  font-weight: 600 !important;
}

.v-input__slot:not(.v-text-field .v-input__slot) {
  background: #e9eaec !important;
  padding: 0.5rem 1rem;
}

.v-text-field .v-input__slot {
  padding: 0.5rem 1rem;
}

.bg-pale-green{
  background: #f1f7f0 !important;
}

.talk__off-payment-details {
  padding: 0px 16px;
}
</style>
